import apiService from './api/ApiService';

const pendoAnalyticsService = {
    async initializePendo({
        onSuccess,
        onFailure,
    }) {
        if (window.pendo) {
            const user = await apiService.fetchLoggedInUser();
            const metadata = {
                visitor: {
                    id: user.userId,
                },
                account: {
                    id: window.marketplaceId,
                    marketplaceName: window.marketplaceName,
                    marketplaceTitle: window.marketplaceTitle,
                    marketplaceUrl: window.marketplaceUrl,
                },
            };
            window.pendo.initialize(metadata);

            if (onSuccess) {
                onSuccess('Pendo is initialized');
            }
        } else if (onFailure) {
            onFailure('Pendo library is not available');
        }
    },
};

export default pendoAnalyticsService;
